module.exports = __webpack_public_path__ + "static/ResponsiveVoice-5fdc12bd735241ac57970caffda61a58.png";